import { Component } from '@angular/core';

@Component({
  selector: 'txp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  host: { class: 'txp-header' },
  standalone: true,
})
export class HeaderComponent {}
